<template>
  <div class="col-md-12">
    <form name="newDocument" @submit.prevent="handleSubmit()">
        <div class="modal-body">
            <label>Name :</label>

            <input name="Name"
                   v-model="encodingData.Name"
                   v-validate="'required|max:120'"
                   class="form-control"
                   :class="{ 'is-invalid': submitted && errors.has('Name') }" />

            <span v-if="submitted && errors.has('Name')" class="invalid-feedback">
                {{
          errors.first("Name")
                }}
            </span>

            <label>Country:</label>

            <select name="SourceId"
                    v-model="encodingData.Country"
                    class="form-control">
                <option value>Select Country</option>
                <option v-for="option in countries"
                        v-bind:value="option.countryName"
                        v-bind:key="option.countryName">
                    {{ option.countryName }}
                </option>
            </select>

            <label>OtherName :</label>

            <input name="OtherName"
                   v-validate="'max:120'"
                   v-model="encodingData.OtherName"
                   class="form-control"
                   :class="{ 'is-invalid': submitted && errors.has('OtherName') }" />

            <span v-if="submitted && errors.has('OtherName')" class="invalid-feedback">
                {{
          errors.first("OtherName")
                }}
            </span>

            <label>State:</label>

            <select name="SourceId"
                    v-model="encodingData.State"
                    class="form-control">
                <option value>Select State</option>
                <option v-for="option in provinces"
                        v-bind:value="option.province"
                        v-bind:key="option.province">
                    {{ option.province }}
                </option>
            </select>

            <label>Type:</label>

            <select name="SourceId"
                    v-model="encodingData.Type"
                    class="form-control">
                <option value>Select Type</option>
                <option v-for="option in types"
                        v-bind:value="option.organizationType"
                        v-bind:key="option.organizationType">
                    {{ option.organizationType }}
                </option>
            </select>

            <label>City :</label>

            <input type="text"
                   name="City"
                   v-model="encodingData.City"
                   class="form-control" />

            <label>Address :</label>

            <input type="text"
                   name="Address"
                   v-model="encodingData.Address"
                   class="form-control" />

            <label>Comments :</label>

            <textarea name="Comments"
                      v-model="encodingData.Comments"
                      class="form-control"
                      cols="5"
                      rows="5" />

            <label>Illegal Activities :</label>

            <textarea name="IllegalActivities"
                      v-model="encodingData.IllegalActivities"
                      class="form-control"
                      cols="5"
                      rows="5" />
        </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstorageOrgType,
} from "../../helper";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        OrganizationId: "",
        Name: "",
        OtherName: "",
        Type: "",
        Comments: "",
        Country: "",
        State: "",
        City: "",
        Address: "",
        IllegalActivities: "",
      },
      countries: [],
      provinces: [],
      types: [],
      submitted: false,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  created: function () {
    this.getlibs();
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          instance
            .post(EncodeURL + "updateOrganization", this.encodingData, {
              headers: authHeader(),
            })
            .then((response) => {
              if (response.data.error) {
                loader.hide()
                notifyHelper(
                  "error",
                  "there was an error processing your request please try again later"
                );
              } else {
                loader.hide()
                notifyHelper("success", "Saved!");
                this.$emit("done-edit-org");
              }
            })
            .catch(function (error) {
              responseCheck(error.response.status);
            });
        }
      });
    },
    getlibs() {
      this.countries = getlocalstorageCountry();
      this.provinces = getlocalstorageProvince();
      this.types = getlocalstorageOrgType();

      this.getOrganization();
    },
    getOrganization() {
      
      instance
        .get(DataURL + "organization?organizationID=" + this.id, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data;
              this.encodingData.OrganizationId = data.organizationId;
              this.encodingData.Name = data.name;
              this.encodingData.OtherName = data.otherName;
              this.encodingData.Type = data.type;
              this.encodingData.Comments = data.comments;
              this.encodingData.Country = data.country;
              this.encodingData.State = data.state;
              this.encodingData.City = data.city;
              this.encodingData.Address = data.address;
              this.encodingData.illegalActivities = data.illegalActivities;
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    },
  },
};
</script>
